var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mstar"},[_vm._l((_vm.stars),function(item,index){return [_c('li',{key:index,staticClass:"star"},[_c('img',{staticClass:"img",attrs:{"src":_vm.score > index ? _vm.selectedSrc : _vm.normalSrc}}),_c('i',{staticClass:"star-a",on:{"click":function($event){return _vm.getScore(item)}}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }